import BillPresentmentDialog from './billPresentmentDialog';

export default BillPresentmentDialog;
